import { Space, Button, message } from 'antd'
import useShowCheckDetail from '../hooks/useShowCheckDetail'
import useFreshCheckList from '../hooks/useFreshCheckList'
import AuthComponent from '../../../components/AuthComponent'
import useAddCheckSheet from '../hooks/useAddCheckSheet'
import service from '../../../@services'
const basicModelOptions = {
  title: '盘点详情'
  // footer: null
}
export default function CheckItemOperateBtns({
  record,
  setShowAdd,
  getList,
  storeCode
}) {
  const { showDetail } = useShowCheckDetail()
  const getDetailShow = () => {
    showDetail(record.checkNo, basicModelOptions)
  }
  // const { freshCheckSheetList } = useFreshCheckList()
  const { showAddCheckSheet } = useAddCheckSheet(setShowAdd, getList, storeCode)
  const deleteCheckSheet = () => {
    let _record = { ...record }
    return service.inventory.deleteCheckSheet(record.checkNo).then(data => {
      if (data) {
        getList()
        message.success(`${_record.sheetName} 盘点单已作废`)
      }
    })
  }
  return (
    <Space>
      {record.checkStatus === 1001 && (
        <>
          <AuthComponent authKey='/inventory/check-sheet/complete'>
            <Button
              type='link'
              size='small'
              onClick={() => showAddCheckSheet(record.checkNo)}>
              继续盘点
            </Button>
          </AuthComponent>
          <AuthComponent authKey='/inventory/check-sheet/delete/{checkNo}'>
            <Button type='link' size='small' onClick={deleteCheckSheet}>
              作废
            </Button>
          </AuthComponent>
        </>
      )}
      <AuthComponent authKey='/inventory/check-sheet/detail/{checkNo}'>
        <Button type='link' size='small' onClick={getDetailShow}>
          详情
        </Button>
      </AuthComponent>
    </Space>
  )
}
